<template>
    <div class="audit-index" v-if="data">
        <div
            :id    = "'scroll-category'"
            :class = "horizontal ? 'scroll-area-horizontal' : 'scroll-area-vertical'"
            :style = "'max-height: ' + (height) + 'px'"
        >
            <v-card
                v-for      = "(entry, index) in entries"
                :id        = "entry.id"
                :key       = "'cat_' + index"
                :elevation = "0"
                :outlined  = "false"
                :rounded   = "false"
                class      = "index-item"
                :class     = "border(index) + ' ' + selectedFrame(entry, selected) + ' ' + constraintBackground(entry)"
                @click     = "onClick (entry.id)"
            >
                <div class="marker-dot" :class="dotBackground(entry, data)">
                </div>

                <div class="pa-1 pl-3 pr-4" style="height: 35px">
                    {{ code(entry) }}
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>

import Core from "@/modules/core/service/Core";
import AuditType from "@/modules/audit/service/AuditType";

export default {
    name: "CAuditIndex",

    props: {
        height: {

        },

        data: {

        },

        index: {

        },

        category: {
        },

        orientation: {

        },

        readonly: {

        },

        /** Catalogue set of the GBU type (HCIT-917); the elevator set of the store if not given. */
        enums: {

        }
    },

    components: {

    },

    data: () => ({
        selected: null,
    }),

    computed: {
        horizontal () {
            return this.orientation === "horizontal";
        },

        auditEnums () {
            return this.enums || this.$store.getters.audit;
        },

        title () {
            return this.auditEnums.categories.find (c => c.id = this.category).name;
        },

        entries () {
            return this.auditEnums.catalogue.filter (e => (!this.category || e.category.id === this.category) && !!this.data.find(entry => entry.catalogue.id === e.id));
        },
    },

    watch: {
        index () {
            if (this.selected && this.index !== this.selected) {
                this.selected = this.entries[this.index];
            }
        },

        category () {
            if (this.entries) {
                this.selected = this.entries[0];
            }
        }
    },

    mounted() {
        this.selected = this.entries[0];
    },

    methods: {
        refresh (entry) {
            this.$nextTick(() => {
                this.selected = entry ? this.entries.find(e => e.id === entry.id) : this.entries[0];
                this.$emit("selected", this.selected)

                this.$nextTick (() => {
                    const scroll  = document.querySelector("#" + 'scroll-category')
                    const element = document.querySelector("#" + this.selected.id);

                    if (element) {
                        Core.scroll.toElement(scroll, element, 1)
                    }
                });
            });
        },

        code (entry) {
            return AuditType.code(entry);
        },

        onClick (entry) {
            this.selected = this.entries.find (e => e.id === entry);
            this.$emit("selected", this.selected)
        },

        constraintBackground () {
            return null; // Audit.constraintBackground(entry);
        },

        border (index) {
            if (this.horizontal) {
                return "";
            }

            if (this.horizontal) {
                return "lm-border";
            }

            if (index === 0) {
                return "top-border-radius top-border-radius-index ";
            }

            if (index === this.entries.length - 1) {
                return this.horizontal ? "" : "bottom-border-radius ";
            }

            return "middle-border-radius ";
        },

        isSelected (entry, selected) {
            return selected && selected.id === entry.id;
        },

        selectedFrame (entry, selected) {
            if (selected && selected.id === entry.id) {
                return this.horizontal ? " primary " : "index-item-vertical primary white--text";
            }

            return this.horizontal ? null : "index-item-vertical";
        },

        dotBackground (entry, data) {
            let rating = null;
            const entryData = data.find(e => e.catalogue.id === entry.id);
            if (entryData) {
                rating = entryData.type.id;
            }

            if (!rating) {
                return null;
            }

            switch (parseInt(rating)) {
                case 1: return "success";
                case 2: return "error";
                case 4: return "warning";
                case 3: return "secondary";
            }

            return null;
        }
    }
}
</script>

<style scoped>

.audit-index {
    padding: 0;
    margin-top: 0;
    width: 100%;
    border-radius: 12px!important;
}

/*noinspection CssUnusedSymbol*/
.scroll-area-horizontal {
    overflow-y: hidden;
    overflow-x: scroll;
    max-width: calc(100% - 0px);
    display: flex;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}

/*noinspection CssUnusedSymbol*/
.scroll-area-vertical {
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}

/*noinspection CssUnusedSymbol*/
.scroll-area-horizontal::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
}

/*noinspection CssUnusedSymbol*/
.scroll-area-vertical::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
}

:deep(.v-card-title) {
    font-size: 15px!important;
    font-weight: 400;
}


.index-item {
    min-width: 70px;
    height: 36px;
    padding-top: 0;
    margin-right: 8px;
    text-align: center;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 4px;
    background-color: white;
}

/*noinspection CssUnusedSymbol*/
.index-item-vertical {
    margin-right: 0;
/*
    border: none;
    border-bottom-style: solid!important;
    border-bottom-width: 1px!important;
    border-bottom-color: lightgray!important;

 */
}

.entry-constraint {
    margin-top: -14px;
    width: 100%;
}

:deep(.text-bold) {
    font-weight: 500;
}

.marker-dot {
    position: absolute;
    width: 10px;
    height: 10px;
    right: 8px;
    top: 8px;
    border-radius: 50%!important;
    border-style: none;
}


</style>
